import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  title: "FitLink Ireland — Find your perfect personal trainer",
  description:
    "The premium marketplace for verified personal trainers across Ireland. Search by county, gym, speciality, price and goal. Book securely online.",
  image: "https://images.unsplash.com/photo-1548690312-e3b507d8c110?w=1200&q=80",
  url: "https://fitlink.ie",
};

export default function SEOHead({ title, description, image, url, type = "website", noIndex = false }) {
  const t = title ? `${title} · FitLink Ireland` : DEFAULTS.title;
  const d = description || DEFAULTS.description;
  const img = image || DEFAULTS.image;
  const u = url || DEFAULTS.url;
  return (
    <Helmet prioritizeSeoTags>
      <title>{t}</title>
      <meta name="description" content={d}/>
      {noIndex && <meta name="robots" content="noindex, nofollow"/>}
      <link rel="canonical" href={u}/>
      <meta property="og:title" content={t}/>
      <meta property="og:description" content={d}/>
      <meta property="og:image" content={img}/>
      <meta property="og:url" content={u}/>
      <meta property="og:type" content={type}/>
      <meta property="og:site_name" content="FitLink Ireland"/>
      <meta property="og:locale" content="en_IE"/>
      <meta name="twitter:card" content="summary_large_image"/>
      <meta name="twitter:title" content={t}/>
      <meta name="twitter:description" content={d}/>
      <meta name="twitter:image" content={img}/>
    </Helmet>
  );
}
